import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const ScreenshotManagement = {
  ScreenshotManagementList: lazyNamed(() => import('./containers/ScreenshotManagementList/index.tsx'), 'ScreenshotManagementList'),
};
